import toast from "components/Toast/dispatch";

export const createDownloadLink = (path: string | undefined) => {
  if (path) {
    const link = document.createElement('a');
    link.href = path;
    link.download = 'download';
    link.click();
  }
};

export const alertCustomerNotSelected = () => {
  toast.info('Atenção', 'Para usar a função "Exportar Dados", favor limite a quantidade de pedidos. Filtre os resultados utilizando um cliente cadastrado.');
};